import React, { useEffect, useState } from 'react';
import {
    createVisualSearchRound,
    GameResultOverlay,
    GameShell,
} from '../shared';
import { formatGameCopy } from './gameCopy';

const CELL_COUNT_BY_LEVEL = [12, 18, 24, 30];

function VisualSearchGame({ copy = {}, initialLevel = 4, ...props }) {
    const level = Math.max(1, Math.min(4, Math.round(Number(initialLevel) || 4)));
    const cellCount = CELL_COUNT_BY_LEVEL[level - 1];
    const [round, setRound] = useState(1);
    const [score, setScore] = useState(0);
    const [streak, setStreak] = useState(0);
    const [trial, setTrial] = useState(() => createVisualSearchRound(1, cellCount));
    const [reviewCellId, setReviewCellId] = useState('');
    const [tone, setTone] = useState('ready');
    const maxRounds = 12;
    const done = round > maxRounds;

    const reset = () => {
        setRound(1);
        setScore(0);
        setStreak(0);
        setTrial(createVisualSearchRound(1, cellCount));
        setReviewCellId('');
        setTone('ready');
    };

    const selectCell = (cell) => {
        if (done || reviewCellId) {
            return;
        }

        const correct = cell.target;
        setScore((value) => value + (correct ? 1 : 0));
        setStreak((value) => (correct ? value + 1 : 0));
        setReviewCellId(cell.id);
        setTone(correct ? 'good' : 'miss');
    };

    const nextRound = () => {
        const nextRound = round + 1;
        setRound(nextRound);
        setReviewCellId('');
        if (nextRound <= maxRounds) {
            setTrial(createVisualSearchRound(nextRound, cellCount));
            setTone('ready');
        }
    };

    useEffect(() => {
        if (!reviewCellId || done) {
            return undefined;
        }

        const timer = window.setTimeout(() => {
            nextRound();
        }, 720);

        return () => window.clearTimeout(timer);
    }, [done, reviewCellId]);

    return (
        <GameShell
            {...props}
            copy={copy}
            metrics={{ level, maxScore: maxRounds, score, streak }}
            tone={done ? 'good' : tone}
        >
            <div className="UFOV-brain-games__game-cue">{copy.visualSearchCue}</div>
            <div className="UFOV-brain-games__target-orb" aria-label={copy.visualSearchCue}>
                <img alt="" draggable="false" src={trial.target.src} />
            </div>
            <div className="UFOV-brain-games__search-grid">
                {trial.cells.map((cell, index) => (
                    <button
                        className={`${cell.muted ? 'is-muted' : ''} ${cell.small ? 'is-small' : ''} ${reviewCellId === cell.id ? 'is-picked' : ''} ${reviewCellId && cell.target ? 'is-target' : ''}`.trim()}
                        key={cell.id}
                        type="button"
                        disabled={done || Boolean(reviewCellId)}
                        onClick={() => selectCell(cell)}
                        aria-label={formatGameCopy(copy.answerOption, { number: index + 1 })}
                    >
                        <img alt="" className={cell.rotate ? 'is-rotated' : ''} draggable="false" src={cell.item.src} />
                    </button>
                ))}
            </div>
            {done ? (
                <GameResultOverlay metrics={{ level, maxScore: maxRounds, score, streak }} onRestart={reset} />
            ) : null}
        </GameShell>
    );
}

export default VisualSearchGame;
